// extracted by mini-css-extract-plugin
export default {"DayScaleRow":"DayScaleRow_DayScaleRow__aSrGn"};